module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/95c0b916b508cfbc403ecd0843b7d80e.png";